// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FRONT-19: Suspension Modal - Design System Centralis */

/* Overlay standard Centralis */
.suspension-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  backdrop-filter: blur(4px);
}

/* Modal container - pattern Centralis (PassationModal) */
.suspension-modal {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 560px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: suspensionSlideIn 0.3s ease-out;
  display: flex;
  flex-direction: column;
}

@keyframes suspensionSlideIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Header */
.suspension-modal-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 30px;
  border-bottom: 1px solid #e5e7eb;
}

.suspension-modal-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  background-color: #fef2f2;
  border-radius: 50%;
}

.suspension-modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Body */
.suspension-modal-body {
  padding: 30px;
}

.suspension-text-primary {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  margin: 0 0 8px 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.suspension-text-secondary {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 24px 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Motif - style view-item du design system */
.suspension-motif {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
}

.suspension-motif-label {
  font-weight: 500;
  color: #6b7280;
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.suspension-motif-text {
  color: #374151;
  font-size: 13px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Date */
.suspension-date {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 24px;
}

.suspension-date-label {
  font-weight: 500;
  color: #6b7280;
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.suspension-date-text {
  font-weight: 500;
  color: #374151;
  font-size: 13px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Contact */
.suspension-contact {
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
}

.suspension-contact p {
  margin: 0 0 6px 0;
  color: #6b7280;
  font-size: 13px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.suspension-contact-link {
  color: #f97316;
  font-weight: 600;
  text-decoration: none;
  font-size: 14px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.suspension-contact-link:hover {
  color: #ea580c;
  text-decoration: underline;
}

/* Footer - pattern Centralis */
.suspension-modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 20px 30px;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

/* Bouton deconnexion - btn-secondary Centralis */
.suspension-logout-btn {
  background-color: transparent;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  transition: background-color 0.2s;
}

.suspension-logout-btn:hover {
  background-color: #f3f4f6;
}

/* Badge suspendu pour l'annuaire - tag standard Centralis */
.annuaire-badge-suspendu {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.5rem;
  font-size: 11px;
  font-weight: 500;
  color: #ef4444;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 0.25rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/composants/SuspensionModal/SuspensionModal.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,yDAAyD;AACzD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,+EAA+E;AACjF;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,+EAA+E;AACjF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,+EAA+E;AACjF;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,+EAA+E;AACjF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+EAA+E;AACjF;;AAEA,SAAS;AACT;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,+EAA+E;AACjF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,+EAA+E;AACjF;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,iDAAiD;AACjD;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+EAA+E;EAC/E,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,+EAA+E;EAC/E,mBAAmB;AACrB","sourcesContent":["/* FRONT-19: Suspension Modal - Design System Centralis */\n\n/* Overlay standard Centralis */\n.suspension-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999;\n  backdrop-filter: blur(4px);\n}\n\n/* Modal container - pattern Centralis (PassationModal) */\n.suspension-modal {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  max-width: 560px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: suspensionSlideIn 0.3s ease-out;\n  display: flex;\n  flex-direction: column;\n}\n\n@keyframes suspensionSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Header */\n.suspension-modal-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 24px 30px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.suspension-modal-header-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  background-color: #fef2f2;\n  border-radius: 50%;\n}\n\n.suspension-modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* Body */\n.suspension-modal-body {\n  padding: 30px;\n}\n\n.suspension-text-primary {\n  font-size: 14px;\n  color: #374151;\n  line-height: 1.6;\n  margin: 0 0 8px 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.suspension-text-secondary {\n  font-size: 13px;\n  color: #6b7280;\n  line-height: 1.6;\n  margin: 0 0 24px 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* Motif - style view-item du design system */\n.suspension-motif {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n}\n\n.suspension-motif-label {\n  font-weight: 500;\n  color: #6b7280;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 4px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.suspension-motif-text {\n  color: #374151;\n  font-size: 13px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* Date */\n.suspension-date {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 12px 16px;\n  margin-bottom: 24px;\n}\n\n.suspension-date-label {\n  font-weight: 500;\n  color: #6b7280;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 4px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.suspension-date-text {\n  font-weight: 500;\n  color: #374151;\n  font-size: 13px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* Contact */\n.suspension-contact {\n  background-color: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 16px;\n}\n\n.suspension-contact p {\n  margin: 0 0 6px 0;\n  color: #6b7280;\n  font-size: 13px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.suspension-contact-link {\n  color: #f97316;\n  font-weight: 600;\n  text-decoration: none;\n  font-size: 14px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.suspension-contact-link:hover {\n  color: #ea580c;\n  text-decoration: underline;\n}\n\n/* Footer - pattern Centralis */\n.suspension-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px 30px;\n  border-top: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n\n/* Bouton deconnexion - btn-secondary Centralis */\n.suspension-logout-btn {\n  background-color: transparent;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n  padding: 0.5rem 1rem;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  transition: background-color 0.2s;\n}\n\n.suspension-logout-btn:hover {\n  background-color: #f3f4f6;\n}\n\n/* Badge suspendu pour l'annuaire - tag standard Centralis */\n.annuaire-badge-suspendu {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.15rem 0.5rem;\n  font-size: 11px;\n  font-weight: 500;\n  color: #ef4444;\n  background-color: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.25rem;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
